module.exports = __webpack_public_path__ + "static/media/chefuxiao1.5490821c.jpg";